import { Page, View, Text, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';

export interface NETPromoterScorePageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const NETPromoterScorePage = ({ event, footer }: NETPromoterScorePageProps) => {
  const { t } = useTranslation();

  const titles = [
    'satisfaction-measurement-title',
    'determine-significance-title',
    'net-promoter-score-38-title',
  ];

  const descriptions = [
    'satisfaction-measurement-text',
    'determine-significance-text',
    'net-promoter-score-38-text',
  ];

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.leftColumn,
        }}
      >
        <Text
          style={{ ...styles.highlightText, color: event?.design?.themeColor }}
        >
          Service that convinces:
        </Text>
        <Text style={{ ...styles.title }}>{'NET PROMOTER SCORE'}</Text>
        <Text style={{ ...styles.title }}>{'IN 2024 = 38!'}</Text>

        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
            marginLeft: 0,
          }}
        />

        <Text style={styles.paragraph}>{t('net-promoter-paragraph')}</Text>

        <Image
          style={styles.image}
          src={
            'https://media.we-conect.com/images/pdf/partnerprospectus/9_1.png'
          }
        />
      </View>

      <View style={styles.rightColumn}>
        <View style={styles.timelineContainer}>
          <View style={styles.timelineLine} />

          {[0, 1, 2].map((_, index) => (
            <View key={index} style={styles.timelineItem}>
              <View style={styles.iconWrapper}>
                <Image
                  style={styles.icon}
                  src={`https://media.we-conect.com/images/pdf/agenda/rocket_4x.png`}
                />
              </View>
              <View style={styles.timelineContent}>
                <Text style={styles.timelineTitle}>{t(titles[index])}</Text>
                <Text style={styles.timelineText}>
                  {t(descriptions[index])}
                </Text>
              </View>
            </View>
          ))}
        </View>
        <Text style={styles.arrowSymbol}>v</Text>
      </View>

      {footer}
    </Page>
  );
};

export default NETPromoterScorePage;
